import Main from "../components/layout/Main";
import HealthcareUsageReport from "../containers/HealthcareUsageReport";
import React from "react";

export const HealthCareUsageReportPage = () => {
    return <Main title="Healthcare Resource Utilisation" containerClassName="white"><HealthcareUsageReport /></Main>
}